import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-3 text-2xl lg:text-3xl font-bold" }
const _hoisted_2 = {
  key: 0,
  class: "my-2 text-xl lg:text-2xl text-gray-700 font-bold"
}
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-700 font-semibold" }, "Transportation plan ID", -1)
const _hoisted_5 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-700 font-semibold" }, "Roadway width", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-700 font-semibold" }, "One-way", -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "w-5 h-5",
  "aria-label": "Image"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 5.25A2.25 2.25 0 013.25 3h13.5A2.25 2.25 0 0119 5.25v9.5A2.25 2.25 0 0116.75 17H3.25A2.25 2.25 0 011 14.75v-9.5zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 00.75-.75v-2.69l-2.22-2.219a.75.75 0 00-1.06 0l-1.91 1.909.47.47a.75.75 0 11-1.06 1.06L6.53 8.091a.75.75 0 00-1.06 0l-2.97 2.97zM12 7a1 1 0 11-2 0 1 1 0 012 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "View cross-sections", -1)
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "w-5 h-5",
  "aria-label": "No symbol"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.965 4.904l9.131 9.131a6.5 6.5 0 00-9.131-9.131zm8.07 10.192L4.904 5.965a6.5 6.5 0 009.131 9.131zM4.343 4.343a8 8 0 1111.314 11.314A8 8 0 014.343 4.343z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "No cross-sections available", -1)
const _hoisted_16 = { class: "text-gray-700 font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Box = _resolveComponent("Box")!
  const _component_Help = _resolveComponent("Help")!
  const _component_Anchor = _resolveComponent("Anchor")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.street.name?.trim() || 'Unnamed segment'), 1),
      (_ctx.street.block)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.street.block) + " block ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.street.id), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.street.width)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.street.width) + " feet", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.street.oneWay !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(_ctx.street.oneWay ? 'Yes' : 'No'), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.crossSectionRoute && !_ctx.street.oneWay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: _ctx.crossSectionRoute,
                custom: ""
              }, {
                default: _withCtx(({ navigate }) => [
                  _createVNode(_component_Button, {
                    label: "View cross-sections",
                    size: "small",
                    onClick: navigate,
                    class: "inline-flex items-center gap-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_Help, {
                help: 
              _ctx.street.oneWay
                ? 'This is a one-way segment'
                : 'This segment is not a typical width'
            
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Box, {
                    color: "gray",
                    variant: "light",
                    class: "text-sm px-2 py-1 inline-flex items-center gap-2 rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["help"])
            ]))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys(_ctx.street), (classification, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "my-2"
        }, [
          _createElementVNode("h2", _hoisted_16, _toDisplayString(classification.charAt(0).toUpperCase() + classification.slice(1)) + " classification ", 1),
          _createVNode(_component_Anchor, {
            url: 
            _ctx.classificationLink(
              classification,
              _ctx.street.classifications[classification]
            )
          
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label(_ctx.street.classifications[classification], classification)), 1)
            ]),
            _: 2
          }, 1032, ["url"])
        ]))
      }), 128))
    ])
  ]))
}